<template>
  <div class="to-user-tasks text-dark">
    <table class="d-table marg-1-bottom d-table__overview">
      <template v-for="(tasksType, prop) in tasksByMasterType">
        <thead>
        <tr>
          <th><h4>{{ tasksType.title }}</h4></th>
          <th>{{ $t('vue2.task_overview.belongs_to') }}</th>
          <th class="is-number">{{ $t('vue2.assign_users_hours.assigned') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="task in tasksType.tasks" :key="task.id">
          <td>{{ task.name }}</td>
          <td>{{ task.calendar }}</td>
          <td class="is-number"><template v-if="!getIsHideHours(task)">{{ task.hours }}</template></td>
        </tr>
        <tr class="to-user_tasks__footer" v-if="!getIsHideTotalHours(tasksType)">
          <td>I alt</td>
          <td></td>
          <td class="is-number">{{ tasksType.totalHours }}</td>
        </tr>
        </tbody>
      </template>
    </table>
  </div>
</template>

<script>
import UserTasksTable from '../UserTasksTable'

export default {
  components: {UserTasksTable},
  props: {
    user: {
      type: Object,
      required: true
    },
    tasks: {
      default: () => []
    },
    isHideTaskHoursUnderThreshold: {
      default: false
    },
    schoolThresholdToHideTaskHours: {
      default: null
    },
    sortOrder: {
      default: null
    },
    tasksByMasterType: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getIsHideHours (task) {
      return task.hours * 1 === 0 || (this.isHideTaskHoursUnderThreshold && task.subject_type === 'additional_tasks' && (task.hours * 1) < this.schoolThresholdToHideTaskHours)
    },
    getIsHideTotalHours (tasksType) {
      return tasksType.totalHours < 1 || (this.isHideTaskHoursUnderThreshold && this.schoolThresholdToHideTaskHours && tasksType.originalType === 'other')
    }
  }
}
</script>

<style scoped>

.d-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
}

.d-table > thead {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th, .d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child {
  color: #8898aa;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 2px 4px;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 4px;
}

.is-number {
  text-align: right;
}

.d-table tr td:first-child {
  padding-left: 2rem;
}


.to-user_tasks__footer {
  border-top: 1px solid #e2e8f0;
}

.to-user_tasks__footer .is-number {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// TaskOverviewUserTasks.vue?44ab4f2c